import sha256 from 'crypto-js/sha256';
import hmacSHA512 from 'crypto-js/hmac-sha512';
import Base64 from 'crypto-js/enc-base64';

export const passwordHash = (pw: string): string => {
  const hashDigest = sha256(pw);
  const privateKey = process.env.VUE_APP_HASH_KEY;
  return Base64.stringify(hmacSHA512(hashDigest.toString(), privateKey));
};

export const passwordVerify = (pw: string, hash: string): boolean => {
  return hash === passwordHash(pw);
};
